import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import type { Variant } from '@/ui/button/button';

import { useValidateUploadedFiles } from './use-validate-uploaded-files';
import { UploadFileInput } from '@/components/upload-file-input/upload-file-input';

export interface UploadFileInputProps {
  onSubmit: (files: File[]) => void;
  variant?: Variant;
  acceptedFiles: string[];
}

export const AutomaticUploadFileButton = ({
  acceptedFiles,
  variant,
  onSubmit,
}: UploadFileInputProps) => {
  const { t } = useTranslation('default');
  const fileInputRef = useRef<HTMLInputElement>(null);

  const { validateUploadedFiles } = useValidateUploadedFiles(acceptedFiles);

  const clearInputValue = () => {
    if (!fileInputRef?.current) return;
    fileInputRef.current.value = '';
  };

  const onFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = validateUploadedFiles(event.target.files || []);
    if (!files) return;

    onSubmit(files);
    clearInputValue();
  };

  return (
    <UploadFileInput
      ref={fileInputRef}
      acceptedFiles={acceptedFiles}
      buttonText={t`actionPanel.files.uploadFile`}
      variant={variant}
      onClick={() => fileInputRef?.current?.click()}
      onUploadFile={onFileInputChange}
      multiple
    />
  );
};
